module.exports = __webpack_public_path__ + "img/logo-school-7.0fbb4e52.png";